import { Action } from '@ngrx/store';

export const AUTH_KEY = 'AUTH';

export enum AuthActionTypes {
  LOGIN = '[Auth] Login',
  LOGOUT = '[Auth] Logout'
}

export class ActionAuthLogin implements Action {
  readonly type = AuthActionTypes.LOGIN;
}

export class ActionAuthLogout implements Action {
  readonly type = AuthActionTypes.LOGOUT;
}

export type AuthActions = ActionAuthLogin | ActionAuthLogout;

export interface AuthState {
  isAuthenticated: boolean;
}

export interface AuthRootState {
  auth: AuthState;
}

export const initialState: AuthState = {
  isAuthenticated: false
};

export const selectorAuth = (state: AuthRootState): AuthState => state.auth;

export const selectorIsAuthenticated = (state: AuthRootState): boolean =>
  selectorAuth(state).isAuthenticated;

export function authReducer(
  state: AuthState = initialState,
  action: AuthActions
): AuthState {
  switch (action.type) {
    case AuthActionTypes.LOGIN:
      return { ...state, isAuthenticated: true };
    case AuthActionTypes.LOGOUT:
      return { ...state, isAuthenticated: false };
    default:
      return state;
  }
}
